import { omit } from 'ramda';
import { ZapierField__Input } from '~/graphql/types';
import { ZapierFields } from '../Details/components/FieldsContainer';

export const cleanedFields = (
  fields: ZapierFields,
): Array<ZapierField__Input> => fields.map(omit(['__typename', 'id']));
